"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react")); // eslint-disable-line


var semantic_ui_react_1 = require("semantic-ui-react"); // eslint-disable-line


exports.InputFile = function (_a) {
  var _b = _a.button,
      button = _b === void 0 ? {} : _b,
      inputProps = _a.input;
  var hiddenInput = null;
  return React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Button, __assign({
    icon: 'upload',
    htmlFor: inputProps.id,
    label: React.createElement(semantic_ui_react_1.Label, {
      as: 'label',
      style: {
        cursor: 'pointer'
      },
      basic: true,
      children: 'Select file'
    }),
    onClick: function onClick() {
      return hiddenInput.click();
    },
    labelPosition: 'right'
  }, button)), React.createElement("input", __assign({
    hidden: true,
    ref: function ref(el) {
      hiddenInput = el;
    },
    type: 'file'
  }, inputProps)));
};